/**
 * Created by hmeerlo on 06/07/15.
 */
import React from 'react';// eslint-disable-line no-unused-vars
import baseComponent from '../../decorators/baseComponent';
import styles from './Notifications.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

@baseComponent(styles)
class Notifications extends BaseReactComponent {

  componentWillReceiveProps(newProps){
    if(newProps.notifications && newProps.notifications.get){
      for(let x of newProps.notifications.get('actions').entries()){
        if(x[1].timeout){
          this.props.onDismiss(undefined, x[0], x[1].timeout);
        }
      }
    }
  }

  onDismiss(key){
    this.props.onDismiss(undefined, key);
  }

  render(){
    var messages;
    if(this.props.notifications && this.props.notifications.get('actions')){
      messages = this.props.notifications.get('actions').map((action) => {
        let key = action.notificationId;
        let classname = 'Notifications-notification';
        if(action.level){
          classname += ' ' + action.level;
        }else{
          classname += ' info';
        }

        return (<li className={classname} key={key} onClick={this.onDismiss.bind(this, key)}>
          <div className="row">
            <div className="col s10">
              {action.text}
            </div>
          </div>
        </li>);
      }).toArray();
    }
    return (<ul className="Notifications">
      <ReactCSSTransitionGroup transitionName="notification" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
        {messages}
      </ReactCSSTransitionGroup>
    </ul>);
  }
}

export default Notifications;



// WEBPACK FOOTER //
// /src/components/Notifications/Notifications.js